package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2
import one.healthium.uscreen.domain.models.FeatureListBlock
import one.healthium.uscreen.domain.models.FeatureListItem
import one.healthium.uscreen.ui.text.toAnnotatedString
import one.healthium.uscreen.ui.util.resolvePlaceholders
import one.healthium.uscreen.ui.util.uscreenPadding

private val EmojiTextGap = 16.dp

@Composable
fun UScreenFeatureListBlock(
    modifier: Modifier = Modifier,
    block: FeatureListBlock,
    isMale: Boolean?,
    placeholders: Map<String, String> = emptyMap(),
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .uscreenPadding(block.padding)
            .testTag("uscreen_feature_list"),
    ) {
        block.title?.let { title ->
            Text(
                text = title.resolvePlaceholders(placeholders).toAnnotatedString(),
                style = AppTheme.textStyles.uscreenBody,
                color = AppTheme.colors.text100,
                modifier = Modifier.padding(bottom = 16.dp),
            )
        }
        block.items.forEachIndexed { index, item ->
            FeatureListRow(
                item = item,
                isMale = isMale,
                placeholders = placeholders,
                emojiHeight = block.emojiHeight,
                showCheckmark = block.showCheckmark,
            )
            if (block.showDivider && index < block.items.lastIndex) {
                Box(
                    modifier = Modifier
                        .height(1.dp)
                        .fillMaxWidth()
                        .padding(start = block.emojiHeight.dp + EmojiTextGap)
                        .background(AppTheme.colors.divider),
                )
            }
        }
    }
}

@Composable
private fun FeatureListRow(
    item: FeatureListItem,
    isMale: Boolean?,
    placeholders: Map<String, String>,
    emojiHeight: Int,
    showCheckmark: Boolean,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(
            modifier = Modifier
                .size(emojiHeight.dp)
                .background(gray_2, AppTheme.shapes.small),
            contentAlignment = Alignment.Center,
        ) {
            Text(
                text = item.emoji.resolve(isMale),
                style = AppTheme.textStyles.body1,
                fontWeight = FontWeight.Bold,
            )
        }

        Spacer(Modifier.width(EmojiTextGap))

        Text(
            text = item.text.resolvePlaceholders(placeholders),
            style = AppTheme.textStyles.body2Medium,
            color = AppTheme.colors.text100,
            modifier = Modifier.weight(1f),
        )

        if (showCheckmark) {
            Spacer(Modifier.width(12.dp))
            AppIcons.icCheckmark(AppTheme.colors.primary)
        }
    }
}
